import { render, staticRenderFns } from "./WindowTitleBar.vue?vue&type=template&id=30d3e93e&scoped=true"
import script from "./WindowTitleBar.vue?vue&type=script&lang=js"
export * from "./WindowTitleBar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30d3e93e",
  null
  
)

export default component.exports